import { NavLink, Outlet } from 'react-router-dom';

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/experiences', label: 'Experiences' },
  { to: '/storage', label: 'Storage' },
  { to: '/webhooks', label: 'Webhooks' },
];

export default function Layout() {
  return (
    <div className="flex min-h-screen">
      <aside className="w-56 shrink-0 border-r border-slate-200 bg-white flex flex-col">
        <div className="px-5 py-6 border-b border-slate-200">
          <div className="text-sm font-semibold text-slate-900">Surprise Admin</div>
          <div className="text-xs text-slate-500 mt-0.5">cumple-yani internal</div>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `block px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-slate-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <a
            href="/cdn-cgi/access/logout"
            className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:bg-slate-100"
          >
            Sign out
          </a>
        </div>
      </aside>
      <main className="flex-1 min-w-0 px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
